export function setOrDeleteParam(
  params: URLSearchParams,
  name: string,
  value: string | undefined,
): void {
  if (value === undefined || value === "") params.delete(name);
  else params.set(name, value);
}

export function parseListParam(value: string | null): string[] {
  return value?.split(",").filter(Boolean) ?? [];
}

export function parseKnownListParam<Value extends string>(
  value: string | null,
  knownValues: readonly Value[],
): Value[] {
  return parseListParam(value).filter((item): item is Value =>
    (knownValues as readonly string[]).includes(item),
  );
}
